import axios from 'axios';

export const createNewUser = async (
    email: string,
    password: string,
    timezoneName: string
): Promise<void> => {
    const url = `/account`;

    return (await axios.post(url, {
        email: email,
        password: password,
        timezoneName: timezoneName,
    })).data;
};

export const changePassword = async (
    currentPassword: string,
    newPassword: string,
    newPasswordConfirmation: string,
): Promise<void> => {
    const url = `/api/account/change_password`;

    return (await axios.post(url, {
        newPassword: newPassword,
        newPasswordConfirmation: newPasswordConfirmation,
        currentPassword: currentPassword,
    })).data;
};

export const login = async (
    email: string,
    password: string
): Promise<void> => {
    const url = `/api/account/login`;

    return (await axios.post(url, {
        email: email,
        password: password
    })).data;
};

export const lostPassword = async (
    email: string,
): Promise<void> => {
    const url = `/api/account/lost_password`;

    return (await axios.post(url, {
        email: email,
    })).data;
};

export const resetPassword = async (
    email: string,
    token: string,
    password: string,
    passwordConfirmation: string,
): Promise<void> => {
    const url = `/api/account/reset_password`;

    return (await axios.post(url, {
        email: email,
        token: token,
        password: password,
        passwordConfirmation: passwordConfirmation,
    })).data;
};

export const checkEmail = async (
    email: string,
): Promise<void> => {
    const url = `/api/account/email?email=` + email;

    return (await axios.get(url)).data;
};